import RestService from '../services/rest';

async function createPromotion({
  startedAt, finalizedAt, productId, type, value, showTimer, released,
}) {
  return RestService.postAuthenticated('panel/promotions/create', {
    startedAt, finalizedAt, productId, type, value, showTimer, released,
  });
}

async function updatePromotion({
  id, startedAt, finalizedAt, productId, type, value, showTimer,
}) {
  return RestService.putAuthenticated('panel/promotions/update', {
    id, startedAt, finalizedAt, productId, type, value, showTimer,
  });
}

async function getPromotions(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/promotions?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function removePromotion(records) {
  return RestService.deleteAuthenticated('panel/promotions/remove', { records });
}

async function getCsvPromotionsReport() {
  const response = await RestService.getAuthenticated('panel/promotions/report/csv', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'promotions-export.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function getCsvPromotionModel() {
  const response = await RestService.getAuthenticated('panel/promotions/csv/model', {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(new Blob(['\ufeff', response]));
  const link = document.createElement('a');
  link.href = url;
  const filePath = 'Modelo_Importação_Promoções CSV.csv';
  link.setAttribute('download', filePath);
  document.body.appendChild(link);
  link.click();
}

async function uploadCsvPromotions(file) {
  const fd = new FormData();
  fd.append('file', file);

  return RestService.postAuthenticated('panel/promotions/import', fd, {
    'Content-Type': 'multipart/form-data',
  });
}

export default {
  createPromotion,
  getPromotions,
  removePromotion,
  updatePromotion,
  getCsvPromotionsReport,
  getCsvPromotionModel,
  uploadCsvPromotions,
};
